import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { links } from "./Navbar.jsx";
import { Link } from "react-router-dom";
import CustomButton from "./CustomButton";

const NavBarMobile = ({ isNavOpen, setIsNavOpen, location }) => {
  const currentYear = new Date().getFullYear();

  const menuVariants = {
    closed: {
      x: "100%",
      transition: {
        type: "spring",
        stiffness: 400,
        damping: 40,
      },
    },
    open: {
      x: 0,
      transition: {
        type: "spring",
        stiffness: 400,
        damping: 40,
      },
    },
  };

  const itemVariants = {
    closed: { x: 50, opacity: 0 },
    open: (i) => ({
      x: 0,
      opacity: 1,
      transition: {
        delay: i * 0.1,
        type: "spring",
        stiffness: 300,
        damping: 24,
      },
    }),
  };

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    if (isNavOpen) {
      document.body.style.overflow = "  hidden";
    } else {
      document.body.style.overflow = previousOverflow || "";
    }
    return () => {
      document.body.style.overflow = previousOverflow || "";
    };
  }, [isNavOpen]);

  return (
    <AnimatePresence>
      {isNavOpen && (
        <>
          {/* Backdrop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40"
            onClick={() => setIsNavOpen(false)}
          />

          {/* Mobile Menu */}
          <motion.div
            initial="closed"
            animate="open"
            exit="closed"
            variants={menuVariants}
            className="fixed top-0 right-0 w-full sm:w-80 h-full z-40 bg-gradient-to-b from-gray-900 to-black text-white shadow-2xl flex flex-col"
          >
            {/* Close Button */}
            {/* <div className="flex justify-end items-center px-6 py-6">
              <button
                onClick={() => setIsNavOpen(false)}
                className="p-2 rounded-full hover:bg-white/10 transition-colors duration-200"
                aria-label="Close menu"
              >
                <svg
                  className="w-6 h-6 text-white"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path d="M6 18L18 6M6 6l12 12"></path>
                </svg>
              </button>
            </div> */}

            <div className="flex flex-col justify-start mt-20 items-center gap-y-6 pt-8 px-8 flex-1 overflow-y-auto">
              {links.map((link, index) => {
                return (
                  <motion.div
                    key={link.name}
                    custom={index}
                    variants={itemVariants}
                    className="w-full"
                  >
                    <Link
                      to={link.href.toLowerCase()}
                      style={link.style}
                      data-to-scrollspy-id={link.spy}
                      className={`block w-full text-center text-lg font-nulshock font-normal py-3 px-4 rounded-lg transition-colors duration-200 hover:bg-white/10`}
                      onClick={() => {
                        setTimeout(() => {
                          setIsNavOpen(false);
                        }, 50);
                      }}
                    >
                      {link.name}
                    </Link>
                  </motion.div>
                );
              })}

              <motion.div
                custom={links.length}
                variants={itemVariants}
                className="w-full mt-4"
              >
                <CustomButton
                  to="/contact-us"
                  className="w-full"
                  size="lg"
                  onClick={() => {
                    setTimeout(() => {
                      setIsNavOpen(false);
                    }, 50);
                  }}
                >
                  Book a Demo
                </CustomButton>
              </motion.div>
            </div>

            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.5 }}
              className="flex justify-center items-center py-6 border-t border-t-white/60 text-sm text-white/60"
            >
              Copyright {currentYear}©
            </motion.p>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default NavBarMobile;
